<template>
  <section class="wrapper">
    <iw-carousel class="hero-carousel" v-bind="settings">
      <!-- 轮播内容 -->
      <iw-carousel-item
        v-for="(item, itemIndex) in slides"
        :key="item.title"
        class="item"
        :style="{ backgroundImage: `url(${item.img})` }"
      >
        <div class="item-wrapper">
          <div class="title">{{ item.title }}</div>
          <div v-if="item.subTitle" class="sub-title">{{ item.subTitle }}</div>
          <div
            v-if="item.descHtml"
            class="desc"
            :class="{
              compact: item.descHtml.length > 120,
              en: isEn,
            }"
            v-html="item.descHtml"
          />
          <a
            v-if="item.url && item.btnText"
            class="btn"
            :href="item.url"
            target="_blank"
          >
            {{ item.btnText }}
          </a>
          <div v-else-if="item.btnText && item.productName">
            <trial-button
              :product-name="item.productName"
              class="try-button btn"
            />
          </div>
          <div v-else-if="item.btnText" class="btn disabled" inert>
            {{ item.btnText }}
          </div>
        </div>
      </iw-carousel-item>
    </iw-carousel>
  </section>
</template>

<script>
import { cloneDeep } from "lodash";
import { mapGetters, mapState } from "vuex";
import lang from '@/lang';
import TrialButton from "../../products/trial-button";
export default {
  name: "HeroCarousel",
  components: {
    TrialButton,
  },
  provide() {
    return {
      getPageData: () => {
        return {
          commonData: cloneDeep(this.commonData),
          authProducts: cloneDeep(this.authProducts),
        };
      },
      resolveImgPath: this.resolveImgPath,
    };
  },
  props: {
    // 公用数据
    commonData: Object,
  },
  data() {
    return {
      isEn: lang.locale === 'en',
      // 轮播参数设置
      settings: {
        height: "464px",
        autoplay: false,
        interval: 5000,
        trigger: "click",
      },
      // 轮播内容
      slides: [
        {
          img: "/images/portal/home/carousel-5.jpg",
          title: this.$t('home.slides1Title' /* 如何进行多数据源交叉分析 */),
          subTitle: null,
          descHtml: this.$t('home.slides1DescHtml' /* 多维数据是为智库用户量身打造的多数据源交叉分析工具；支持用户灵活自由组合，无需SQL编程能力和开发人员支持，通过拖拉拽即可轻松自如地完成数据的提取和探查工作。 */),
          btnText: this.$t('home.Applyfortrial' /* 申请试用 */),
          productName: this.$t('home.slides1ProductName' /* 多维数据 */),
          url: null,
        },
        {
          img: "/images/portal/home/carousel-6.jpg",
          title: this.$t('home.slides2Title' /* 整车全指标图片如何一站式查看 */),
          subTitle: null,
          descHtml: this.$t('home.slides2DescHtml' /* 车型体验库是一款可进行整车全指标图片分析的产品，通过更全面、更细颗粒度的场景化车型图片，辅助用户进行整车产品分析。 */),
          btnText: this.$t('home.Applyfortrial' /* 申请试用 */),
          productName: this.$t('home.slides1ProductName' /* 车型体验库 */),
          url: null,
        },
        {
          img: "/images/portal/home/carousel-1.jpg",
          title: this.$t('home.slides3Title' /* 整车在市场中智能水平如何 */),
          subTitle: null,
          descHtml: this.$t('home.slides3DescHtml' /* 通过功能广度、功能深度、用户体验、用户洞察、OTA成长性这五个维度， 对整车的智能化程度进行综合性评价，助您更好的评判本竞品车型在智能化方面的综合竞争力。 */),
          btnText: this.$t('home.Trynow' /* 立即体验 */),
          url: "https://iev.way-s.cn/intelligent",
        },
        {
          img: "/images/portal/home/carousel-2.jpg",
          title: this.$t('home.slides4Title' /* 如何快速调整购车权益 */),
          subTitle: null,
          descHtml: this.$t('home.slides4DescHtml' /* 通过长期稳定检测，建立完善的结构化权益数据库。方便行业了解车企购车权益营销内容。<br />
          助您进行各品牌、车型购车权益营销方面的对标分析，掌握行业营销发展趋势。 */),
          btnText: this.$t('home.Trynow' /* 立即体验 */),
          url: "https://iev.way-s.cn/promotion",
        },
      ],
    };
  },
  computed: {
    ...mapGetters(["token"]),
    ...mapState("portal", ["authProducts", "productsData", "solutionsData"]),
  },
};
</script>

<style lang="scss" scoped>
@import "../../styles/common";
@keyframes tracking-in-effect {
  0% {
    letter-spacing: 0.6em;
    filter: blur(20px);
    opacity: 0;
  }
  40% {
    opacity: 0.2;
  }
  100% {
    filter: blur(0);
    opacity: 1;
  }
}
@-webkit-keyframes fade-in-effect {
  0% {
    transform: translateY(10px);
    opacity: 0;
  }
  100% {
    transform: translateY(0);
    opacity: 1;
  }
}
.wrapper {
  margin-bottom: 80px;
  .hero-carousel {
    .item {
      display: flex;
      align-items: flex-start;
      justify-content: center;
      background: #b8d6f6 linear-gradient(160deg, #8aa5d6 0%, #b8d6f6 100%)
        no-repeat center/cover;
      color: #292b33;
      &-wrapper {
        width: $content-width;
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        justify-content: flex-start;
        gap: 32px;
        // margin-top: 128px;
        margin-top: 96px;
      }
      .title,
      .sub-title {
        font-family: "banner-shuhei", "Helvetica Neue", Helvetica, Arial,
          "PingFang SC", "Hiragino Sans GB", "Heiti SC", "Microsoft YaHei",
          "WenQuanYi Micro Hei", sans-serif;
        font-weight: 700;
        letter-spacing: 1px;
      }
      .title {
        max-width: $content-width;
        font-size: 60px;
        line-height: 1.2;
      }
      .sub-title {
        margin-top: -28px;
        font-size: 20px;
        line-height: 1.2;
      }
      .desc {
        max-width: 794px;
        font-size: 14px;
        line-height: 1.8;
        &.en {
          max-width: 902px;
          font-family: Alibaba PuHuiTi 2.0;
          font-size: 18px !important;
          font-weight: 400;
          line-height: 32px;
          text-align: left;
          text-underline-position: from-font;
          text-decoration-skip-ink: none;
        }
        &.compact {
          margin: -8px 0;
          font-size: 14px;
          line-height: 1.4;
        }
      }
      .btn,
      .try-button {
        cursor: pointer;
        display: flex;
        align-items: center;
        justify-content: center;
        height: 40px;
        width: 220px;
        background-color: $color-blue;
        color: #fff;
        font-size: 18px;
        line-height: 1;
        border-radius: 4px;
        transition: background-color 0.2s;
        &:hover {
          background-color: lighten($color-blue, 5%);
          border-color: lighten($color-blue, 5%);
        }
        &:active {
          background-color: darken($color-blue, 10%);
          border-color: darken($color-blue, 10%);
        }
        &.disabled {
          color: $color-blue;
          background: transparent;
          border: 1px solid #9db8ff;
          pointer-events: none;
        }
      }
      &.is-active {
        .title {
          animation: tracking-in-effect 1s 0.2s
            cubic-bezier(0.215, 0.61, 0.355, 1) both;
        }
        .sub-title {
          animation: fade-in-effect 0.8s 0.6s
            cubic-bezier(0.39, 0.575, 0.565, 1) both;
        }
        .desc {
          animation: fade-in-effect 0.8s 0.6s
            cubic-bezier(0.39, 0.575, 0.565, 1) both;
        }
        .btn {
          animation: fade-in-effect 0.8s 0.8s
            cubic-bezier(0.39, 0.575, 0.565, 1) both;
        }
      }
    }
  }
  .hero-carousel /deep/ {
    $B: iw-carousel;
    .#{$B}__arrow {
      width: 80px;
      height: 80px;
      margin-top: 8px;
      background-color: rgba(#000, 0.12);
      color: #fff;
      &:hover {
        background-color: rgba(#000, 0.24);
      }
      &:active {
        background-color: rgba(#000, 0.12);
      }
      &--left {
        left: 64px;
      }
      &--right {
        right: 64px;
      }
      @media (max-width: ($page-min-width + 64px * 2)) {
        &--left {
          left: 12px;
          transform: scale(0.64) translateY(-50%);
        }
        &--right {
          right: 12px;
          transform: scale(0.64) translateY(-50%);
        }
      }
      > i {
        font-size: 32px;
        font-weight: bold;
      }
    }
    .#{$B}__indicators {
      width: $content-width;
      bottom: 32px;
      .#{$B}__indicator {
        .#{$B}__button {
          width: 40px;
          height: 4px;
          background: transparent;
          position: relative;
          &::before,
          &::after {
            content: " ";
            display: block;
            width: 100%;
            height: 100%;
            background-color: rgba(0, 0, 0, 0.08);
            position: absolute;
            left: 0;
            top: 0;
            z-index: 0;
            pointer-events: none;
            transition: background-color 0.2s;
          }
          &::after {
            width: 0;
            background-color: #507cff;
            z-index: 10;
          }
        }
        &.is-active {
          .#{$B}__button {
            &::after {
              width: 100%;
              transition: width 5s;
            }
          }
        }
      }
    }
  }
}
:root.ie {
  .wrapper {
    .hero-carousel {
      .item {
        &.is-active {
          .title,
          .desc,
          .btn {
            animation: none;
          }
        }
      }
    }
  }
}
</style>
